import React, { useState, useEffect } from "react";
import { api_get, api_post } from "../../helpers/index";
import AddSpinAcquisition from "../../core/modals/spin/addspinacquisition";
import Swal from "sweetalert2";

const SpinConfig = () => {
  const [tokenPerSpin, setTokenPerSpin] = useState("");
  const [maxSpinPerDay, setMaxSpinPerDay] = useState("");
  const [errors, setErrors] = useState({});
  const [userPermission, setUserPermission] = useState("");
  const [spinActiveStatus, setSpinActiveStatus] = useState("active");

  useEffect(() => {
    fetchSpinConfig();
    fetchUserPermission();
    handleRetrieveAcquisitionList();
  }, []);

  const fetchSpinConfig = async () => {
    try {
      const response = await api_get("spinwheel/spin/config");
      if (response.status === 1 && response.data) {
        setTokenPerSpin(response.data.token_per_spin);
        setMaxSpinPerDay(response.data.maximum_spin_per_day);
        setSpinActiveStatus(response.data.spin_active_status || "active");
      } else {
        console.error("Failed to fetch spin configuration");
      }
    } catch (error) {
      console.error("Error fetching spin configuration:", error);
    }
  };

  const fetchUserPermission = async () => {
    const response = await api_post("user/profile");
    if (response.status === 1) {
      setUserPermission(response.data.permission);
    }
  };

  const handleUpdateConfig = async () => {
    const newErrors = {};
    if (!tokenPerSpin) newErrors.tokenPerSpin = "Token per spin is required.";
    if (!maxSpinPerDay) newErrors.maxSpinPerDay = "Maximum spin per day is required.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    const body = {
      token_per_spin: Number(tokenPerSpin),
      maximum_spin_per_day: Number(maxSpinPerDay),
    };

    // Only include spin_active_status if user is superadmin
    if (userPermission === "superadmin") {
      body.spin_active_status = spinActiveStatus;
    }

    try {
      const response = await api_post("spinwheel/spin/update_config", body);
      if (response.status === 1) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Configuration updated successfully!"
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update configuration. Please try again later."
        });
      }
    } catch (error) {
      console.error("Error updating configuration:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while updating the configuration. Please try again later."
      });
    }
  };

  const handleRetrieveAcquisitionList = async (keyword = "") => {
    try {
      const response = await api_get(`spinwheel/spin/acquisition/list?keyword=${keyword}`);
      if (response.status === 1) {
        setAcquisitionList(response.data);
      } else {
        console.error("Failed to fetch acquisition list");
      }
    } catch (error) {
      console.error("Error fetching acquisition list:", error);
    }
  };

  return (
    <div className="page-wrapper cardhead">
      <div className="content container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header justify-content-between">
                <div className="card-title">Spin Configuration</div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Token Required Per Spin</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Tokens"
                      value={tokenPerSpin}
                      onChange={(e) => setTokenPerSpin(e.target.value)}
                    />
                    {errors.tokenPerSpin && (
                      <div className="text-danger mt-1">{errors.tokenPerSpin}</div>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Maximum Spin Allowed Per Day</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Max Spins"
                      value={maxSpinPerDay}
                      onChange={(e) => setMaxSpinPerDay(e.target.value)}
                    />
                    {errors.maxSpinPerDay && (
                      <div className="text-danger mt-1">{errors.maxSpinPerDay}</div>
                    )}
                  </div>
                  {userPermission === "superadmin" && (
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Spinwheel Front Active Status</label>
                      <div className="radio">
                        <label>
                          <input 
                            type="radio" 
                            name="spinActiveStatus" 
                            value="active"
                            checked={spinActiveStatus === "active"}
                            onChange={(e) => setSpinActiveStatus(e.target.value)}
                          /> Active
                        </label>
                      </div>
                      <div className="radio">
                        <label>
                          <input 
                            type="radio" 
                            name="spinActiveStatus" 
                            value="inactive"
                            checked={spinActiveStatus === "inactive"}
                            onChange={(e) => setSpinActiveStatus(e.target.value)}
                          /> Inactive
                        </label>
                      </div>
                    </div>
                  )}
                  <div className="col-md-12">
                    <button type="button" className="btn btn-primary" onClick={handleUpdateConfig}>
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddSpinAcquisition onSuccess={handleRetrieveAcquisitionList} />
    </div>
  );
};

export default SpinConfig;